define('modules/form_editor/views/editor_custom_month',['require','exports','module','./editor_dropdown','./editor_custom_month_item'],function(require, exports, module){
  "use strict";
  var EditorDropDown = require("./editor_dropdown");

  module.exports = EditorDropDown.extend({
    itemView: require("./editor_custom_month_item"),
    helpers: function() {
      return {
        hasUrlLoad: false,
        hasCsvLoad: false
      };
    }
  });
});

